import { SET_VIEW_ALL, SET_SHOP_TYPE_FILTER } from './constants';

const initialState = {
  viewAll: false,
  shopTypeId: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_VIEW_ALL:
      return {
        ...state,
        viewAll: action.payload,
      };
    case SET_SHOP_TYPE_FILTER:
      return {
        ...state,
        shopTypeId: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;